var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"liveStop"},[_c('a',{staticClass:"buttom",on:{"click":function($event){return _vm.backLivePage()}}},[_vm._v("返回直播页")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }